<div class="recover-modal">
  <button type="button" class="recover-modal__close" (click)="dialogRef.close()" aria-label="Cerrar">
    <i class="material-icons">close</i>
  </button>

  <div class="recover-modal__icon" aria-hidden="true">
    <i class="material-icons">lock_reset</i>
  </div>

  <h2 class="recover-modal__title">Recupera tu contraseña</h2>
  <p class="recover-modal__subtitle">
    Ingresa el correo asociado a tu cuenta y te enviaremos las instrucciones
    para restablecer tu contraseña.
  </p>

  <form [formGroup]="formulario" class="recover-modal__form" (ngSubmit)="enviarCorreo()">
    <label class="recover-modal__label" for="correoRecuperar">Correo electrónico</label>

    <div class="recover-modal__field"
      [class.is-invalid]="formulario.controls.correo.invalid && (formulario.controls.correo.dirty || formulario.controls.correo.touched)">
      <i class="material-icons" aria-hidden="true">email</i>
      <input notCopyPaste id="correoRecuperar" type="email" formControlName="correo"
        placeholder="correo@ejemplo.com" autocomplete="email">
    </div>

    <p class="recover-modal__error"
      *ngIf="formulario.controls.correo.invalid && (formulario.controls.correo.dirty || formulario.controls.correo.touched)">
      Ingresa un correo electrónico válido.
    </p>

    <button type="submit" class="recover-modal__btn" [disabled]="formulario.invalid">
      Enviar correo
    </button>
  </form>
</div>
